import { createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const LinkContext = /* @__PURE__ */ createContext(null);
const LinkProvider = ({
  CustomLink,
  children
}) => /* @__PURE__ */ jsx(LinkContext.Provider, {
  value: CustomLink,
  children
});

export { LinkContext, LinkProvider };
//# sourceMappingURL=LinkContext.js.map
